<template>
  <div :style="[
    {fontSize: item.size === 'xxs' ? '11px'
    : item.size === 'xs' ? '13px'
    : item.size === 'sm' ? '14px'
    : item.size === 'md' ? '16px'
    : item.size === 'lg' ? '19px'
    : item.size === 'xl' ? '22px'
    : item.size === 'xxl' ? '29px'
    : item.size === '3xl' ? '35px'
    : item.size === '4xl' ? '48px'
    : item.size === '5xl' ? '74px'
    : item.size, fontWeight: item.weight},
    item.color?{color: item.color}:{},
    item.align?{
      textAlign: item.align,
      justifyContent: item.align
    }:{}
  ]" :class="[
  !item.gravity ? ''
  :item.gravity==='center'?'grvC'
  :item.gravity==='bottom'?'grvB'
  : ''
  ]">
  <template v-if="item.contents&&item.contents.length>0">
  <span v-for="(txt, t) in item.contents" :key="t" :style="[
    txt.size?{
      fontSize: txt.size === 'xxs' ? '11px'
    : txt.size === 'xs' ? '13px'
    : txt.size === 'sm' ? '14px'
    : txt.size === 'md' ? '16px'
    : txt.size === 'lg' ? '19px'
    : txt.size === 'xl' ? '22px'
    : txt.size === 'xxl' ? '29px'
    : txt.size === '3xl' ? '35px'
    : txt.size === '4xl' ? '48px'
    : txt.size === '5xl' ? '74px'
    : txt.size
    }:{},
    txt.weight?{fontWeight: txt.weight}:{},
    txt.color?{color: txt.color}:{},
    txt.style?{fontStyle: txt.style}:{},
    txt.decoration?{textDecoration: txt.decoration}:{},
  ]">{{txt.text}}</span>
  </template>
  <p v-else :style="[
    item.size?{
      fontSize: item.size === 'xxs' ? '11px'
    : item.size === 'xs' ? '13px'
    : item.size === 'sm' ? '14px'
    : item.size === 'md' ? '16px'
    : item.size === 'lg' ? '19px'
    : item.size === 'xl' ? '22px'
    : item.size === 'xxl' ? '29px'
    : item.size === '3xl' ? '35px'
    : item.size === '4xl' ? '48px'
    : item.size === '5xl' ? '74px'
    : item.size
    }:{},
    item.weight?{fontWeight: item.weight}:{},
    item.color?{color: item.color}:{},
    item.align?{textAlign: item.align}:{},
  ]">{{item.text}}</p>
  </div>
</template>

<script>
export default {
  props: ['item']

}
</script>

<style lang="scss" scoped>
p {
  text-overflow: clip;
  word-wrap: break-word;
  white-space: normal;
}
.grvC {
  -webkit-box-pack: center;
  justify-content: center;
}
.grvB {
  -webkit-box-pack: end;
  justify-content: flex-end;
}

</style>
